const STORAGE_KEY = "kap_recent_activities";
const MAX_ENTRIES = 20;

export type ActivityType = "task_complete" | "mail" | "approval" | "chart" | "event";

export interface ActivityEntry {
  id: string;
  time: string;
  text: string;
  type: ActivityType;
  date: string; // YYYY-MM-DD
}

export function logActivity(text: string, type: ActivityType = "task_complete"): void {
  const existing = getStoredActivities();
  const now = new Date();
  const timeStr = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  const dateStr = now.toISOString().slice(0, 10);

  const entry: ActivityEntry = {
    id: `act_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    time: timeStr,
    text,
    type,
    date: dateStr,
  };

  const updated = [entry, ...existing].slice(0, MAX_ENTRIES);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // ignore storage errors
  }
}

export function getStoredActivities(): ActivityEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as ActivityEntry[];
  } catch {
    // ignore
  }
  return [];
}

export function clearActivities(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
